import { CheckIcon } from 'lucide-react';
import { palettes } from './marketingOptions';
import type { PaletteKey } from '../../core/types/marketing';
type Props = {
  value: PaletteKey;
  onChange: (key: PaletteKey) => void;
};

/** Kleurkeuze: elk staal toont achtergrond, tekst en accent samen. */
export function PaletteSelect({
  value,
  onChange
}: Props) {
  return <div role="radiogroup" aria-label="Kleur" className="grid grid-cols-3 gap-2 sm:grid-cols-6" data-id="element-3074" data-mp="3nmze8le6ywov">
      {palettes.map(p => {
      const on = p.key === value;
      return <button key={p.key} type="button" role="radio" aria-checked={on} onClick={() => onChange(p.key)} className={`group rounded-md p-1 text-left transition-colors duration-150 ease-soft ${on ? 'bg-white ring-2 ring-ink' : 'ring-1 ring-line hover:ring-ink/30'}`} data-id="element-3075" data-mp="1cwvucml879g">
            <span className="relative flex h-12 items-end justify-between rounded px-2 pb-1.5" style={{
          background: p.bg
        }} aria-hidden="true" data-id="element-3076" data-mp="k3xuezjsq0sh">
              <span className="font-display text-[18px] leading-none" style={{
            color: p.fg
          }} data-id="element-3077" data-mp="2lyis2fzlmq3t">
                Aa
              </span>
              <span className="h-2.5 w-2.5 rounded-full" style={{
            background: p.accent
          }} data-id="element-3078" data-mp="2cw9jvwrsz8tl" />
              {on && <span className="absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-white text-ink" data-id="element-3079" data-mp="27y835ihunlla">
                  <CheckIcon className="h-3 w-3" strokeWidth={2.5} data-id="element-3080" data-mp="35knlemi3on9w" />
                </span>}
            </span>
            <span className="mt-1 block px-0.5 text-[12px] text-ink" data-id="element-3081" data-mp="30ogbyjqhwtn7">{p.name}</span>
          </button>;
    })}
    </div>;
}